"use strict";

var _slicedToArray = require("/codebuild/output/src490952806/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _defineProperty = require("/codebuild/output/src490952806/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _objectSpread = require("/codebuild/output/src490952806/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");
var _objectWithoutProperties = require("/codebuild/output/src490952806/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutocompleteSingleSelect = exports.AutocompleteMultiSelect = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _reactSelect = _interopRequireDefault(require("react-select"));
var _styles = require("@material-ui/core/styles");
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Chip = _interopRequireDefault(require("@material-ui/core/Chip"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _Cancel = _interopRequireDefault(require("@material-ui/icons/Cancel"));
var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));
var _async = _interopRequireDefault(require("react-select/async"));
var _creatable = _interopRequireDefault(require("react-select/creatable"));
var _asyncCreatable = _interopRequireDefault(require("react-select/async-creatable"));
var _icons = require("../assets/js/icons");
var _helpers = require("./utils/helpers");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var inputHeight = 52;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    chip: {
      '& .MuiChip-deleteIcon': {
        margin: 0
      },
      '& .MuiChip-label': {
        margin: '0 2px 0 4px',
        padding: 0,
        position: 'static'
      },
      borderRadius: '14px',
      display: 'flex',
      height: '28px',
      justifyContent: 'space-between',
      margin: '4px 10px 4px -6px',
      width: 'auto'
    },
    chipFocused: {
      backgroundColor: (0, _styles.emphasize)(theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700], 0.08)
    },
    input: {
      backgroundColor: theme.palette.background.paper,
      borderRadius: '36px',
      display: 'flex',
      height: 'inherit',
      padding: 0
    },
    menuItem: {
      '&.Mui-selected': {
        backgroundColor: theme.palette.type === 'light' ? _helpers.agentDeveloperUtils.getSecondaryColor(100) : 'rgba(0,0,255,.1)',
        color: theme.palette.text.primary,
        fontWeight: 500
      },
      '&:active, &:focus, &:hover': {
        backgroundColor: theme.palette.background.default
      },
      '&:hover': {
        '& $menuItemTooltip': {
          opacity: 1
        }
      },
      borderBottom: "1px solid ".concat(_helpers.agentDeveloperUtils.getSecondaryColor(100)),
      borderRight: "1px solid ".concat(_helpers.agentDeveloperUtils.getSecondaryColor(100)),
      color: theme.palette.text.secondary,
      fontSize: theme.typography.fontSize,
      height: '50px',
      left: 0,
      paddingBottom: '4px',
      paddingTop: '5px',
      position: 'relative',
      width: '100%'
    },
    menuItemTooltip: {
      backgroundColor: theme.palette.background.paper,
      left: 5,
      lineHeight: 1,
      opacity: 0,
      padding: 5,
      pointerEvents: 'auto',
      position: 'absolute',
      top: 0,
      width: '100%'
    },
    noOptionsMessage: {
      padding: theme.spacing(1, 2)
    },
    optionIcon: {
      '& .MuiAvatar-root': {
        borderRadius: 0,
        width: 52
      },
      marginRight: 12,
      width: 52
    },
    paper: {
      '&>div': {
        margin: 0,
        maxHeight: 282,
        minHeight: 149,
        paddingBottom: 0,
        paddingTop: 0
      },
      border: "1px solid ".concat(_helpers.agentDeveloperUtils.getSecondaryColor(100)),
      borderRadius: '12px',
      bottom: function bottom(props) {
        return props.menuPlacement === 'top' ? props.size === 'small' ? 40 : inputHeight : undefined;
      },
      boxShadow: 'none',
      left: 0,
      marginTop: theme.spacing(1),
      maxHeight: 282,
      minHeight: 149,
      overflow: 'hidden',
      position: 'absolute',
      right: 0,
      // eslint-disable-next-line no-negated-condition
      top: function top(props) {
        return props.menuPlacement !== 'top' ? props.size === 'small' ? 40 : inputHeight : undefined;
      },
      zIndex: 10
    },
    placeholder: {
      bottom: function bottom(props) {
        return props.size === 'small' ? 10 : 14;
      },
      fontSize: function fontSize(props) {
        return props.size === 'small' ? 13 : 16;
      },
      left: 20,
      position: 'absolute'
    },
    root: {
      '& fieldset': {
        borderRadius: 36
      },
      '& legend>span': {
        paddingLeft: 0,
        paddingRight: 0
      },
      '&>div': {
        height: 'inherit'
      },
      '&>div>.MuiFormControl-root': {
        height: 'inherit'
      },
      '&>div>.MuiFormControl-root>div': {
        height: 'inherit'
      },
      flexGrow: 1,
      height: function height(props) {
        return props.size === 'small' ? 40 : inputHeight;
      },
      minWidth: function minWidth(props) {
        return props.size === 'small' ? 'auto' : 220;
      },
      width: '100%'
    },
    searchIndicator: {
      '&>svg': {
        backgroundColor: 'transparent',
        height: '14.8px',
        width: '14.8px'
      },
      cursor: 'pointer',
      height: '24px',
      margin: '0 10px 0 0',
      paddingTop: 4,
      width: '24px'
    },
    singleValue: {
      // fontSize: 16,
      marginLeft: 12
    },
    valueContainer: {
      alignItems: 'center',
      display: 'flex',
      flex: 1,
      flexWrap: 'wrap',
      overflow: 'hidden',
      padding: '0 10px 0 16px'
    }
  };
});
function NoOptionsMessage(props) {
  return /*#__PURE__*/_react.default.createElement(_Typography.default, _extends({
    color: "textSecondary",
    className: props.selectProps.classes.noOptionsMessage
  }, props.innerProps), props.children);
}
NoOptionsMessage.propTypes = {
  children: _propTypes.default.node,
  innerProps: _propTypes.default.object,
  selectProps: _propTypes.default.object
};
function inputComponent(_ref) {
  var inputRef = _ref.inputRef,
    props = _objectWithoutProperties(_ref, ["inputRef"]);
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    ref: inputRef
  }, props));
}
inputComponent.propTypes = {
  inputRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.any
  })])
};
function Control(props) {
  var children = props.children,
    innerProps = props.innerProps,
    innerRef = props.innerRef,
    _props$selectProps = props.selectProps,
    classes = _props$selectProps.classes,
    TextFieldProps = _props$selectProps.TextFieldProps,
    name = _props$selectProps.name;
  return /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({
    fullWidth: true,
    name: name ? name : undefined,
    InputProps: {
      inputComponent: inputComponent,
      inputProps: _objectSpread({
        children: children,
        className: classes.input,
        ref: innerRef
      }, innerProps)
    }
  }, TextFieldProps));
}
Control.propTypes = {
  children: _propTypes.default.node,
  /**
   * The mouse down event and the innerRef to pass down to the controller element.
   */
  innerProps: _propTypes.default.shape({
    onMouseDown: _propTypes.default.func
  }),
  innerRef: _propTypes.default.oneOfType([_propTypes.default.oneOf([null]), _propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.any
  })]),
  selectProps: _propTypes.default.object
};
function Option(props) {
  return /*#__PURE__*/_react.default.createElement(_MenuItem.default, _extends({
    ref: props.innerRef,
    component: "div",
    className: props.selectProps.classes.menuItem,
    selected: props.isSelected,
    "data-testid": "autocomplete-option-".concat(props.value),
    "data-value": props.value,
    disabled: props.data.disabled
  }, props.innerProps, {
    onClick: function onClick(event) {
      if (!props.data.disabled) {
        props.innerProps.onClick(event);
      }
    }
  }), props.data.imgSrc ? /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, {
    className: props.selectProps.classes.optionIcon
  }, /*#__PURE__*/_react.default.createElement(_Avatar.default, {
    src: props.data.imgSrc,
    alt: '',
    "aria-hidden": "true"
  })) : false, props.children, props.data.disabledTooltip ? /*#__PURE__*/_react.default.createElement("span", {
    className: props.selectProps.classes.menuItemTooltip
  }, /*#__PURE__*/_react.default.createElement("sub", null, props.data.disabledTooltip, /*#__PURE__*/_react.default.createElement("br", null), props.data.disabledTooltip_line_2)) : null);
}
Option.propTypes = {
  children: _propTypes.default.node,
  data: _propTypes.default.object,
  innerProps: _propTypes.default.shape({
    id: _propTypes.default.string,
    key: _propTypes.default.string,
    onClick: _propTypes.default.func,
    onMouseMove: _propTypes.default.func,
    onMouseOver: _propTypes.default.func,
    tabIndex: _propTypes.default.number
  }),
  /**
   * Inner ref to DOM Node
   */
  innerRef: _propTypes.default.oneOfType([_propTypes.default.oneOf([null]), _propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.any
  })]),
  isFocused: _propTypes.default.bool,
  isSelected: _propTypes.default.bool,
  selectProps: _propTypes.default.object,
  value: _propTypes.default.any
};
function Placeholder(props) {
  var selectProps = props.selectProps,
    _props$innerProps = props.innerProps,
    innerProps = _props$innerProps === void 0 ? {} : _props$innerProps,
    children = props.children;
  return /*#__PURE__*/_react.default.createElement(_Typography.default, _extends({
    color: "textSecondary",
    className: selectProps.classes.placeholder
  }, innerProps), children);
}
Placeholder.propTypes = {
  children: _propTypes.default.node,
  innerProps: _propTypes.default.object,
  selectProps: _propTypes.default.object
};
function SingleValue(props) {
  return /*#__PURE__*/_react.default.createElement(_Typography.default, _extends({
    variant: "body2",
    className: props.selectProps.classes.singleValue
  }, props.innerProps), props.children);
}
SingleValue.propTypes = {
  children: _propTypes.default.node,
  innerProps: _propTypes.default.any,
  selectProps: _propTypes.default.object
};
function ValueContainer(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: props.selectProps.classes.valueContainer
  }, props.children);
}
ValueContainer.propTypes = {
  children: _propTypes.default.node,
  selectProps: _propTypes.default.object
};
function MultiValue(props) {
  return /*#__PURE__*/_react.default.createElement(_Chip.default, {
    tabIndex: -1,
    label: props.children,
    className: (0, _clsx.default)(props.selectProps.classes.chip, _defineProperty({}, props.selectProps.classes.chipFocused, props.isFocused)),
    onDelete: props.removeProps.onClick,
    deleteIcon: /*#__PURE__*/_react.default.createElement(_Cancel.default, props.removeProps)
  });
}
MultiValue.propTypes = {
  children: _propTypes.default.node,
  isFocused: _propTypes.default.bool,
  removeProps: _propTypes.default.shape({
    onClick: _propTypes.default.func,
    onMouseDown: _propTypes.default.func,
    onTouchEnd: _propTypes.default.func
  }),
  selectProps: _propTypes.default.object
};
function Menu(props) {
  return /*#__PURE__*/_react.default.createElement(_Paper.default, _extends({
    className: props.selectProps.classes.paper
  }, props.innerProps), props.children);
}
Menu.propTypes = {
  children: _propTypes.default.element,
  innerProps: _propTypes.default.object,
  selectProps: _propTypes.default.object
};
function DropdownIndicator(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: props.selectProps.classes.searchIndicator,
    alt: '',
    "aria-hidden": "true"
  }, /*#__PURE__*/_react.default.createElement(_icons.Search, null));
}
DropdownIndicator.propTypes = {
  selectProps: _propTypes.default.object
};
function IndicatorSeparator() {
  return false;
}
var components = {
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  IndicatorSeparator: IndicatorSeparator,
  Menu: Menu,
  MultiValue: MultiValue,
  NoOptionsMessage: NoOptionsMessage,
  Option: Option,
  Placeholder: Placeholder,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};

// ----------------------------------------- //
//       components that are exported:       //
// ----------------------------------------- //

var AutocompleteSingleSelect = function AutocompleteSingleSelect(props) {
  var suggestions = props.items;
  var onInput = props.onInput,
    isCreatable = props.isCreatable;
  inputHeight = props.inputHeight ? props.inputHeight : 52;
  var classes = useStyles(props);
  var theme = (0, _styles.useTheme)();
  var _react$default$useSta = _react.default.useState(props.defaultValue || null),
    _react$default$useSta2 = _slicedToArray(_react$default$useSta, 2),
    single = _react$default$useSta2[0],
    setSingle = _react$default$useSta2[1];
  var defaultId = 'react-select-single-' + (Math.random() * 1e8).toString(36);
  var _react$default$useSta3 = _react.default.useState(false),
    _react$default$useSta4 = _slicedToArray(_react$default$useSta3, 2),
    inputHasTypedValue = _react$default$useSta4[0],
    setInputHasTypedValue = _react$default$useSta4[1];
  var initSelectedFromParent = function initSelectedFromParent(parentValue, suggs) {
    if (parentValue === null) {
      setSingle(null);
    } else {
      var selectedOption = (0, _helpers.findSelectedOption)(parentValue, suggs);
      setSingle(selectedOption);
    }
  };

  // happens on init
  _react.default.useEffect(function () {
    if (onInput) {
      if (!props.parentValue) {
        return;
      }
      var selectedOption = onInput(props.parentValue);
      if (!selectedOption) {
        return;
      }

      // in case of selectedOption (from default(parent)Value) has multiple records than filter only excatly one we need
      setSingle(selectedOption.filter(function (item) {
        return item.label === props.parentValue;
      }));
    } else {
      // null or number like 312
      initSelectedFromParent(props.parentValue, props.items);
    }
  }, [props.parentValue]);
  var handleChangeSingle = function handleChangeSingle(selection) {
    setSingle(selection);
    if (props.onSelect) {
      if (selection === null) {
        props.onSelect(selection);
      } else {
        props.onSelect(selection);
      }
    }
  };
  var handleInputChange = function handleInputChange(typedValue) {
    /* listens to keystrokes and gets the 'typedValue', should effect the inputLabel-shrink */
    setInputHasTypedValue(Boolean(typedValue));
  };
  var loadOptions = function loadOptions(inputValue, callback) {
    callback(onInput(inputValue));
  };
  var selectStyles = {
    input: function input(base) {
      return _objectSpread(_objectSpread({}, base), {}, {
        '& input': {
          font: 'inherit'
        },
        color: theme.palette.text.primary
      });
    }
  };
  var staticProps = {
    autoFocus: props.autoFocus,
    cacheOptions: props.cacheOptions,
    classes: classes,
    components: components,
    defaultMenuIsOpen: props.defaultMenuIsOpen ? props.defaultMenuIsOpen : false,
    inputId: props.id ? props.id : defaultId,
    isClearable: true,
    menuPlacement: props.menuPlacement || 'auto',
    name: props.name ? props.name : undefined,
    noOptionsMessage: function noOptionsMessage(value) {
      return value.inputValue ? 'אין תוצאות' : null;
    },
    onChange: handleChangeSingle,
    onInputChange: handleInputChange,
    placeholder: props.placeholder && !props.inputLabel ? props.placeholder : '',
    styles: selectStyles,
    TextFieldProps: {
      helperText: props.helperText ? props.helperText : '',
      InputLabelProps: {
        htmlFor: props.id ? props.id : defaultId,
        shrink: Boolean(single) || inputHasTypedValue
      },
      label: props.inputLabel ? props.inputLabel : ''
    },
    value: single
  };
  var AsyncAutocomplete = /*#__PURE__*/_react.default.createElement(_async.default, _extends({
    loadOptions: loadOptions
  }, staticProps));
  var NormalAutocomplete = /*#__PURE__*/_react.default.createElement(_reactSelect.default, _extends({
    options: suggestions
  }, staticProps));
  var CreatableAutocomplete = /*#__PURE__*/_react.default.createElement(_creatable.default, _extends({
    options: suggestions
  }, staticProps, {
    formatCreateLabel: function formatCreateLabel(inputValue) {
      return inputValue;
    }
  }));
  var AsyncCreatableAutocomplete = /*#__PURE__*/_react.default.createElement(_asyncCreatable.default, _extends({
    loadOptions: loadOptions,
    formatCreateLabel: function formatCreateLabel(inputValue) {
      return inputValue;
    }
  }, staticProps));
  var component = NormalAutocomplete;
  var isAsync = onInput && !suggestions;
  if (isAsync) {
    component = AsyncAutocomplete;
  }
  if (isCreatable) {
    component = isAsync ? AsyncCreatableAutocomplete : CreatableAutocomplete;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, component);
};
exports.AutocompleteSingleSelect = AutocompleteSingleSelect;
AutocompleteSingleSelect.propTypes = {
  autoFocus: _propTypes.default.bool,
  cacheOptions: _propTypes.default.bool,
  defaultMenuIsOpen: _propTypes.default.bool,
  defaultValue: _propTypes.default.object,
  helperText: _propTypes.default.string,
  id: _propTypes.default.string,
  inputHeight: _propTypes.default.number,
  inputLabel: _propTypes.default.string,
  isCreatable: _propTypes.default.bool,
  items: _propTypes.default.array,
  menuPlacement: _propTypes.default.oneOf(['top', 'bottom', 'auto']),
  name: _propTypes.default.string,
  onInput: _propTypes.default.func,
  onSelect: _propTypes.default.func,
  parentValue: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  placeholder: _propTypes.default.string,
  size: _propTypes.default.oneOf(['small', 'medium'])
};
AutocompleteSingleSelect.defaultProps = {
  cacheOptions: true,
  size: 'medium'
};
var AutocompleteMultiSelect = function AutocompleteMultiSelect(props) {
  var suggestions = props.items;
  inputHeight = props.inputHeight ? props.inputHeight : 52;
  var _react$default$useSta5 = _react.default.useState(null),
    _react$default$useSta6 = _slicedToArray(_react$default$useSta5, 2),
    multi = _react$default$useSta6[0],
    setMulti = _react$default$useSta6[1];
  var defaultId = 'react-select-multiple-' + (Math.random() * 1e8).toString(36);
  var _react$default$useSta7 = _react.default.useState(false),
    _react$default$useSta8 = _slicedToArray(_react$default$useSta7, 2),
    inputHasTypedValue = _react$default$useSta8[0],
    setInputHasTypedValue = _react$default$useSta8[1];
  var classes = useStyles(props);
  var theme = (0, _styles.useTheme)(props);
  var initSelectedFromParent = function initSelectedFromParent(parentValue, suggs) {
    if (parentValue === null) {
      setMulti(null);
    } else {
      var selectedOptions = parentValue.map(function (value_) {
        return (0, _helpers.findSelectedOption)(value_, suggs);
      });
      setMulti(selectedOptions);
    }
  };
  _react.default.useEffect(function () {
    if (!props.parentValue || !props.parentValue.length) {
      return;
    }
    initSelectedFromParent(props.parentValue, props.items);
  }, []);
  var handleChangeMulti = function handleChangeMulti(selection) {
    setMulti(selection);
    if (props.onSelect) {
      props.onSelect(selection);
    }
  };
  var handleInputChange = function handleInputChange(typedValue) {
    /* listens to keystrokes and gets the 'typedValue', should effect the inputLabel-shrink */
    setInputHasTypedValue(Boolean(typedValue));
  };
  var selectStyles = {
    input: function input(base) {
      return _objectSpread(_objectSpread({}, base), {}, {
        '& input': {
          font: 'inherit'
        },
        color: theme.palette.text.primary
      });
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_reactSelect.default, {
    classes: classes,
    styles: selectStyles,
    name: props.name ? props.name : undefined,
    inputId: props.id ? props.id : defaultId,
    TextFieldProps: {
      helperText: props.helperText ? props.helperText : '',
      InputLabelProps: {
        htmlFor: props.id ? props.id : defaultId,
        shrink: Boolean(multi) || inputHasTypedValue
      },
      label: props.inputLabel ? props.inputLabel : ''
    },
    placeholder: props.placeholder && !props.inputLabel ? props.placeholder : '',
    options: suggestions,
    components: components,
    value: multi,
    onChange: handleChangeMulti,
    onInputChange: handleInputChange,
    defaultMenuIsOpen: props.defaultMenuIsOpen ? props.defaultMenuIsOpen : false
    /* eslint-disable-next-line jsx-a11y/no-autofocus */,
    autoFocus: props.autoFocus,
    isMulti: true
  }));
};
exports.AutocompleteMultiSelect = AutocompleteMultiSelect;
AutocompleteMultiSelect.propTypes = {
  autoFocus: _propTypes.default.bool,
  defaultMenuIsOpen: _propTypes.default.bool,
  helperText: _propTypes.default.string,
  id: _propTypes.default.string,
  inputHeight: _propTypes.default.number,
  inputLabel: _propTypes.default.string,
  items: _propTypes.default.array,
  name: _propTypes.default.string,
  onSelect: _propTypes.default.func,
  parentValue: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.number]),
  placeholder: _propTypes.default.string
};